import React from 'react';
import createSVG from '../createSVG';

const GrundlagenIconBig = ({style}) => (
  <path style={style} fill="none" fillRule="evenodd" stroke="#6ED2A0" strokeWidth="3" d="M2 109h21.4m0-21.4h21.4m0-21.4h21.4m0-21.4h21.4m0-21.4H109M23.4 109V87.6m21.4 0V66.2m21.4 0V44.8m21.4 0V23.4m21.4 0V2" strokeLinecap="round"/>
);

export default createSVG(GrundlagenIconBig);
